import React, { useState, useEffect } from "react";
import { Container, Flex, Stack } from "@mantine/core";
import { Footer } from "../navigation/Footer";
import LoginTopSection from "../../template/login/LoginTopSection";
import LoginTabsSection from "../../template/login/LoginTabsSection";
import LoginUserSection from "../../template/login/LoginUserSection";
import CurvingSentences from "../CurvingSentences";

// 랜덤 문장 배열
const randomSentences = [
	"모든 지식은 경험에서 시작됩니다",
	"최고의 아이디어는 경험의 교차점에서 탄생합니다",
	"창의성은 실패를 두려워하지 않는 용기입니다",
	"당신의 이야기가 세상을 변화시킬 수 있습니다",
	"인사이트는 데이터를 넘어서는 직관입니다",
	"분석은 과거를, 통찰은 미래를 보여줍니다",
	"성장은 과거의 자신을 뛰어넘는 것입니다",
	"영감은 준비된 사람에게 찾아옵니다",
	"작은 습관이 큰 변화를 만듭니다",
	"가치 있는 콘텐츠는 시간이 지나도 빛납니다",
	"데이터는 이야기가 될 때 의미를 가집니다",
];

const LoginPresent = ({
	svgRef,
	name,
	email,
	isSubmitting,
	handleLogin,
	handleWaitlist,
	setName,
	setEmail,
}) => {
	// 배경 애니메이션을 위한 랜덤 문장 선택
	const [backgroundSentences, setBackgroundSentences] = useState([]);

	useEffect(() => {
		// 랜덤 문장 5개 선택
		const getRandomSentences = (count) => {
			const shuffled = [...randomSentences].sort(() => 0.5 - Math.random());
			return shuffled.slice(0, count);
		};

		setBackgroundSentences(getRandomSentences(7));
	}, []);

	return (
		<Container w={"100%"} align={"center"} style={{ position: "relative" }}>
			{/* 배경 애니메이션 - 뷰포트 크기로 고정 */}
			<CurvingSentences sentences={backgroundSentences} isBackground={false} />
			
			<Container
				w={{ base: "100%", sm: "csm" }}
				px={{ base: "1rem", sm: "2rem" }}
				py={{ base: "2rem", sm: "3rem", md: "4rem" }}
			>
				<Flex
					w={"100%"}
					justify={"center"}
					align={"center"}
					direction={"column"}
					gap={{ base: "1.5rem", sm: "2.5rem", md: "3rem" }}
					py={{ base: "1rem", sm: "2rem", md: "3rem" }}
				>
					<LoginTopSection />
					<Stack align={"center"} w={"100%"} gap={{ base: "1rem", sm: "1.5rem" }}>
						<LoginTabsSection svgRef={svgRef} />
						<LoginUserSection
							name={name}
							email={email}
							isSubmitting={isSubmitting}
							handleLogin={handleLogin}
							handleWaitlist={handleWaitlist}
							setName={setName}
							setEmail={setEmail}
						/>
					</Stack>
				</Flex>
			</Container>
			<Footer />
		</Container>
	);
};

export default LoginPresent;
